//Instalados
import { useState, useEffect, useCallback } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { MRT_Localization_PT_BR } from "material-react-table/locales/pt-BR";
import Modal from "../../Modais/VisualModal";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import XLSX from "sheetjs-style";
import * as FileSaver from "file-saver";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

//CSS
import "./css/table.css";
import "./css/scroll-styles.css";
import "./css/FilteringTable.css";
import "./css/style.css";
import "./css/Modal.css";
import {
  MaterialReactTable,
  type MRT_ColumnDef,
  MRT_Row,
  MRT_RowSelectionState,
} from "material-react-table";
import { readDataStorage, writeStorage } from "../../../utils/storage/storage";
import { useProgress } from "../../../hooks/progress";
import api from "../../../services/api/index";
import { Box, Button } from "@mui/material";
import { useAPI } from "../../../hooks/contextApis";
import isBetween from "dayjs/plugin/isBetween";
import dayjs, { Dayjs } from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { FilterFn, Row } from "@tanstack/react-table";
import { RangeDataFilter } from "./RangeDataFilter";
import { TempChanger } from "./TempChanger";

export type Data = {
  idCard: string;
  criacaoCard: string;
  status_arp: string;
  vendedor_nome: string;
  situa_o_arp: string;
  visualizado_representante: string;
  observa_o: string;
  mensalidade_axs: string;
  nomeTitular: string;
  data_contrato_assinado: string;
  temperatura_da_proposta: "Frio" | "Morno" | "Quente" | "";
};
type TableRow = {
  original: Record<string, any>;
};

export const Table = () => {
  const { pageIndex, pageSize } = readDataStorage("paginacao");
  const { TipoVendedor, CpfRepresentante, CnpjRepresentante, Equipe } =
    readDataStorage("login");
  const [modalIsOpen, setIsOpen] = useState(false);
  const closeModal = () => {
    setIsOpen(false);
    closeModalRequest();
  };
  const { isLoad, setLoad } = useProgress();
  const [isNome, setIsNome] = useState();
  const [isMensalidade, setIsMensalidade] = useState();
  const [isTelefone, setIsTelefone] = useState();
  const [isEmail, setIsEmail] = useState();
  const [isEndereco, setIsEndereco] = useState();
  const [isCidade, setIsCidade] = useState();
  const [isConcessionaria, setIsConcessionaria] = useState();
  const [isUnidadeConsumidora, setIsUnidadeConsumidora] = useState();
  const [isDtCriacao, setIsDtCriacao] = useState();
  const [isDtAtualizacao, setIsDtAtualizacao] = useState();
  const [isStatus, setIsStatus] = useState();
  const [isLink, setIsLink] = useState();
  const [isIdCard, setIsIdCard] = useState();
  const [isFatura, setIsFatura] = useState();
  const [isDescri_o, setIsDescri_o] = useState();
  const [isChaveWhats, setIsChaveWhats] = useState();
  const [isTotalReenvio, setIsTotalReenvio] = useState();
  const [list, setList] = useState<string[]>([]);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: pageIndex,
    pageSize: pageSize,
  });

  const [data, setData] = useState<Data[]>([]);
  const [vendedores, setVendedores] = useState();
  const [somaMensalidade, setSomaMensalidade] = useState<string>("");
  const { Cards } = readDataStorage("dados");
  const { setIsOpenUser, setDataUser } = useAPI();

  dayjs.locale("pt-br");

  const fetchData = useCallback(async () => {
    const { Cards } = readDataStorage("dados");
    setData(Cards);

    let modifiedData = Cards.map(function (option: any, i: any) {
      if (option.status_arp) {
        return option.status_arp;
      }
      if (!option.status_arp) {
        return " ";
      }
      return option.status_arp;
    });

    let modifiedDataVendedores = Cards.map(function (option: any, i: any) {
      if (option.vendedor_nome) {
        return option.vendedor_nome;
      }
      if (!option.vendedor_nome) {
        return " ";
      }
      return option.vendedor_nome;
    });

    const filteredVendedores = modifiedDataVendedores.filter(
      (item: any, index: any) => modifiedDataVendedores.indexOf(item) === index
    );
    const filteredVendedoresOrder = filteredVendedores.sort();
    setVendedores(filteredVendedoresOrder);

    const filtered = modifiedData.filter(
      (item: any, index: any) => modifiedData.indexOf(item) === index
    );
    const filteredOrder = filtered.sort();
    setList(filteredOrder);
  }, []);

  const dataSend = useCallback((id, tipo, formato) => {
    let object = {
      id: id,
      tipo: tipo,
      formato: formato,
    };
    return object;
  }, []);

  const setDados = useCallback(
    async ({ id, tipo, formato }) => {
      setLoad(true);
      api.defaults.headers.common = {
        Authorization: `bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
      };
      await api
        .get(
          "/csp/representante/pipefy/card/" +
            formato +
            "/consultar?" +
            tipo +
            "=" +
            id
        )
        .then((res) => {
          if (res.status === 200) {
            setLoad(false);
            const removeItem = (arr: any, refId: any) => {
              return arr.filter(function (i: any) {
                return i.situa_o_arp !== refId;
              });
            };
            const arr = removeItem(res.data["cards"], "inativo");

            writeStorage({
              key: "dados",
              object: {
                Cards: arr,
              },
            });
            fetchData();
          }
        })
        .catch((error) => {
          setLoad(false);
        });
    },
    [setLoad, fetchData]
  );

  const closeModalRequest = useCallback(async () => {
    switch (TipoVendedor) {
      case "Representante Legal":
        setDados(dataSend(CnpjRepresentante, "rep", "cnpj"));
        break;
      case "Vendedor":
        setDados(dataSend(CpfRepresentante, "ven", "cpf"));
        break;
      case "Coordenador de Equipes":
        setDados(dataSend(Equipe, "equipe", "equipe"));
        break;
      default:
        //setDados(CnpjRepresentante)
        break;
    }
  }, [
    TipoVendedor,
    dataSend,
    setDados,
    CnpjRepresentante,
    CpfRepresentante,
    Equipe,
  ]);

  const leituraModal = useCallback(
    (id) => {
      setLoad(true);
      api.get(`/csp/cliente/consultar/card/` + id).then((res) => {
        setIsNome(res.data.empresa);
        setIsDescri_o(res.data.descri_o);
        setIsMensalidade(res.data.mensalidade_axs);
        setIsTelefone(res.data.telefone_do_titular_da_conta);
        setIsEmail(res.data.email);
        setIsEndereco(res.data.rua);
        setIsCidade(res.data.cidade);
        setIsConcessionaria(res.data.concession_ria);
        setIsUnidadeConsumidora(res.data.n_mero_da_instala_o_cemig_1);
        setIsDtCriacao(res.data.criacaoCard);
        setIsDtAtualizacao(res.data.dataAlteracao);
        setIsStatus(res.data.status_arp);
        setIsLink(res.data.link_da_proposta);
        setIsIdCard(res.data.idCard);
        setIsFatura(res.data.fatura);
        setIsChaveWhats(res.data.chave_whatsapp);
        setIsTotalReenvio(res.data.total_reenvio_contrato);
        setDataUser(res.data);
        setLoad(false);
        //setIsOpen(true);
        setIsOpenUser(true);
      });
    },
    [setLoad, setIsOpenUser, setDataUser]
  );

  const updateModal = useCallback(
    (id) => {
      leituraModal(id);
    },
    [leituraModal]
  );

  const visualizarRepresentante = useCallback(
    (rowIdxVisual) => {
      api.defaults.headers.common = {
        Authorization: `bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
      };
      setLoad(true);
      api
        .post(`/csp/usuario/alterar/visualizadoRepresentante/`, {
          idCard: rowIdxVisual["idCard"],
        })
        .then((res) => {
          setLoad(false);
          leituraModal(rowIdxVisual["idCard"]);
        });
    },
    [setLoad, leituraModal]
  );

  function numberPoint(numero: any) {
    // eslint-disable-next-line
    var numero = numero.toFixed(2).split(".");
    numero[0] = numero[0].split(/(?=(?:...)*$)/).join(".");
    return numero.join(",");
  }

  const handleShowVisual = useCallback(
    (rowIdxVisual) => {
      visualizarRepresentante(rowIdxVisual);
    },
    [visualizarRepresentante]
  );

  useEffect(() => {
    const lastIdCard = localStorage.getItem("@ARP-Energia:LastIdCard");
    if (lastIdCard && data.length) {
      localStorage.setItem("@ARP-Energia:LastIdCard", "");
      const row = data.find((item) => item.idCard === lastIdCard);
      if (row) handleShowVisual(row);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  dayjs.extend(isBetween);
  dayjs.extend(isSameOrAfter);
  dayjs.extend(isSameOrBefore);

  const dateRangeFilterFn: FilterFn<Data> = (
    row: Row<Data>,
    columnId: string,
    filterValue?: { from: Dayjs | null; to: Dayjs | null }
  ): boolean => {
    if (!filterValue) {
      return true;
    }

    const { from, to } = filterValue;

    if (!from && !to) {
      return true;
    }

    const cellValue = row.getValue<string>(columnId);

    if (!cellValue) {
      return false;
    }

    const cellDate = dayjs(cellValue, "DD/MM/YYYY");

    if (!cellDate.isValid()) {
      return false;
    }

    const fromDate = from ? from.startOf("day") : null;
    const toDate = to ? to.endOf("day") : null;

    if (fromDate && toDate) {
      return cellDate.isBetween(fromDate, toDate, null, "[]");
    } else if (fromDate) {
      return cellDate.isSameOrAfter(fromDate);
    } else if (toDate) {
      return cellDate.isSameOrBefore(toDate);
    }

    return true;
  };

  const columns: MRT_ColumnDef<Data>[] = [
    {
      id: "idCard",
      header: "ID Card",
      accessorKey: "idCard",
    },
    {
      id: "temperatura_da_proposta",
      header: "Temperatura",
      filterVariant: "select",
      filterSelectOptions: ["Frio", "Morno", "Quente"],
      accessorKey: "temperatura_da_proposta",
      Cell: ({ row }) => {
        const { idCard, temperatura_da_proposta } = row.original;
        return (
          <TempChanger
            idCard={idCard}
            temperatura={temperatura_da_proposta}
            onChange={closeModalRequest}
          />
        );
      },
    },
    {
      id: "nomeTitular",
      header: "Nome do titular da conta",
      accessorKey: "nomeTitular",
      Cell: ({ cell, row }) => {
        const handleDados = useCallback((rowIdxVisual) => {
          return rowIdxVisual;
        }, []);
        let rowData = handleDados(row.original);

        const Visual = rowData.visualizado_representante;
        const Tipo = rowData.tipo;

        return (
          <div
            className="ButtonNome"
            style={
              Visual === "Não"
                ? { color: "#6C5AF4", fontWeight: "700" }
                : { color: "black" }
            }
            onClick={() => handleShowVisual(cell.row.original)}
          >
            <span
              className="Bolinha"
              style={Visual === "Não" ? {} : { display: "none" }}
            ></span>
            <span style={Tipo === "PF" || "PJ" ? {} : { display: "none" }}>
              {cell.getValue()}
            </span>
          </div>
        );
      },
    },
    {
      header: "Status",
      accessorKey: "status_arp",
      filterVariant: "select",
      filterSelectOptions: list,
    },
    {
      header: "Mensalidade AXS",
      accessorKey: "mensalidade_axs",
      Cell: ({ row }) => {
        const handleDados = useCallback((rowIdxVisual) => {
          return rowIdxVisual;
        }, []);
        let rowData = handleDados(row.original);

        const value = rowData.mensalidade_axs;

        return (
          <span style={{ textAlign: "right", display: "block" }}>
            R$ {numberPoint(Number(value))}
          </span>
        );
      },
    },
    {
      header: "Observação",
      accessorKey: "observa_o",
      Cell: ({ row }) => {
        const handleDados = useCallback((rowIdxVisual) => {
          return rowIdxVisual;
        }, []);
        let rowData = handleDados(row.original);
        function truncateString(value: any) {
          if (value.length > 30) {
            return value.slice(0, 30) + "...";
          }
          return value;
        }
        const value = rowData.observa_o;

        return <span className={"truncate-text"}>{value}</span>;
      },
    },
    {
      id: "criacaoCard",
      accessorKey: "criacaoCard",
      header: "Data de criação",
      Filter: RangeDataFilter,

      Cell: ({ row }) => {
        const handleDados = useCallback(
          (rowIdxVisual: Data) => rowIdxVisual,
          []
        );
        const rowData = handleDados(row.original);
        const value = rowData.criacaoCard;

        return <span>{value}</span>;
      },
      filterFn: dateRangeFilterFn,
      sortingFn: (
        rowA: Row<Data>,
        rowB: Row<Data>,
        columnId: string
      ): number => {
        const dateA = rowA.original[columnId as keyof Data] as string;
        const dateB = rowB.original[columnId as keyof Data] as string;

        const parsedDateA = dayjs(dateA, "DD/MM/YYYY");
        const parsedDateB = dayjs(dateB, "DD/MM/YYYY");

        if (!parsedDateA.isValid() && !parsedDateB.isValid()) return 0;
        if (!parsedDateA.isValid()) return 1;
        if (!parsedDateB.isValid()) return -1;

        return parsedDateA.diff(parsedDateB);
      },
    },
    {
      filterFn: dateRangeFilterFn,
      id: "data_contrato_assinado",
      header: "Finalização",
      accessorKey: "data_contrato_assinado",
      Cell: ({ row }) => {
        const handleDados = useCallback(
          (rowIdxVisual: Data) => rowIdxVisual,
          []
        );
        const rowData = handleDados(row.original);
        const value = rowData.data_contrato_assinado;

        return <span>{value}</span>;
      },
      muiFilterDatePickerProps: {
        disableFuture: true,
        format: "DD/MM/YYYY",
        slotProps: {
          popper: {
            sx: {
              "& .MuiBox-root": {
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              },
            },
          },
          textField: {
            fullWidth: false,
            sx: {
              width: "175px",
              "& .MuiInputBase-root": {
                position: "relative",
              },
              "& .MuiIconButton-edgeEnd": {
                position: "absolute",
                right: "30px",
              },
              "& .MuiInputBase-input": {
                paddingRight: "60px",
              },
            },
          },
        },
      },
      Filter: RangeDataFilter,
      sortingFn: (
        rowA: Row<Data>,
        rowB: Row<Data>,
        columnId: string
      ): number => {
        const dateA = rowA.original[columnId as keyof Data] as string;
        const dateB = rowB.original[columnId as keyof Data] as string;

        const parsedDateA = dayjs(dateA, "DD/MM/YYYY");
        const parsedDateB = dayjs(dateB, "DD/MM/YYYY");

        if (!parsedDateA.isValid() && !parsedDateB.isValid()) return 0;
        if (!parsedDateA.isValid()) return 1;
        if (!parsedDateB.isValid()) return -1;

        return parsedDateA.diff(parsedDateB);
      },
    },

    {
      id: "Vendedor",
      header: "Vendedor",
      accessorKey: "vendedor_nome",
      filterVariant: "select",
      filterSelectOptions: vendedores,
    },

    {
      id: "Visualizado Representante",
      header: "Visualizado Representante",
      accessorKey: "visualizado_representante",
    },
  ];

  const calculateSum = (rows: TableRow[], columnId: string) => {
    const total = rows.reduce((sum, row) => {
      const value = row.original[columnId];
      return sum + (typeof value === "number" ? value : Number(value));
    }, 0);
    const formattedTotal = total.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });

    setSomaMensalidade(formattedTotal);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const ExportExcel = (excelData: any, fileName: any) => {
    const fileType =
      "application/vnd.openxIformats-officedocument.spreadsheetml.sheet; charset=UTF-8";
    const fileExtension = ".xlsx";

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const handleExportRows = (rows: MRT_Row<Data>[]) => {
    const data = rows.map((row) => row.original);
    const result = Cards;
    result.map((el: any) => {
      delete el["vendedor_nome"];
      return result;
    });

    if (TipoVendedor === "Vendedor") {
      ExportExcel(result, "AXS");
    } else {
      ExportExcel(data, "AXS");
    }
  };

  const handleExportData = () => {
    const dados = data.map((data) => data);
    const result = Cards;

    result.map((el: any) => {
      delete el["vendedor_nome"];
      return result;
    });

    if (TipoVendedor === "Vendedor") {
      ExportExcel(result, "AXS");
    } else {
      ExportExcel(dados, "AXS");
    }
  };

  const theme = createTheme({
    palette: {
      secondary: {
        main: "#6C5AF4",
      },
    },
  });

  useEffect(() => {
    writeStorage({
      key: "paginacao",
      object: {
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      },
    });
  }, [pagination.pageIndex, pagination.pageSize]);

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className="VisualModal">
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            onUpdate={updateModal}
            fatura={isFatura}
            id={isIdCard}
            mensalidade={isMensalidade}
            telefoneCliente={isTelefone}
            emailCliente={isEmail}
            endereco={isEndereco}
            cidade={isCidade}
            concessionaria={isConcessionaria}
            unidade={isUnidadeConsumidora}
            dtCriacao={isDtCriacao}
            dtAtualizacao={isDtAtualizacao}
            status={isStatus}
            linkArp={isLink}
            nome={isNome}
            descri_o={isDescri_o}
            chaveWhats={isChaveWhats}
            totalReenvio={isTotalReenvio}
          />
        </div>
        <ThemeProvider theme={theme}>
          <MaterialReactTable
            columns={columns}
            muiTablePaperProps={{
              sx: {
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
              },
            }}
            data={data ?? []}
            onPaginationChange={setPagination}
            state={{
              showSkeletons: isLoad,
              rowSelection,
              pagination: {
                pageSize: pagination.pageSize,
                pageIndex: pagination.pageIndex,
              },
            }}
            initialState={{
              pagination: { pageSize: pageSize, pageIndex: pageIndex },
              density: "compact",
              sorting: [{ id: "criacaoCard", desc: true }],
              showColumnFilters: true,
              columnVisibility: {
                "Visualizado Representante": false,
                Vendedor: TipoVendedor === "Vendedor" ? false : true,
              },
            }}
            enableGlobalFilter={false}
            //enableRowSelection={({ row }) => row.original.nomeTitular }
            enableRowSelection
            muiTableBodyRowProps={() => ({
              sx: {
                // sobrescreve a classe default de linha selecionada
                "&.MuiTableRow-root td:after": {
                  backgroundColor: "#F3F3FB", // cor de fundo
                },
                // quando a linha estiver selecionada e em hover
                "&.MuiTableRow-root td:after:hover": {
                  backgroundColor: "#F3F3FB",
                },
              },
            })}
            onRowSelectionChange={setRowSelection}
            muiSelectAllCheckboxProps={{ color: "secondary" }}
            muiSelectCheckboxProps={{ color: "secondary" }}
            positionToolbarAlertBanner="bottom"
            localization={MRT_Localization_PT_BR}
            enableHiding={false}
            enableFullScreenToggle={false}
            muiToolbarAlertBannerProps={{
              sx: {
                "& .MuiButton-colorPrimary ": {
                  color: "#6c5af4 !important",
                  textDecoration: "none",
                },
                "& .MuiButton-colorPrimary:hover ": {
                  backgroundColor: "transparent",
                  textDecoration: "underline",
                },
              },
            }}
            renderBottomToolbarCustomActions={({ table }) => {
              const selectedRows = table.getSelectedRowModel().rows;
              const rowsToCalculate =
                selectedRows.length > 0
                  ? selectedRows
                  : table.getFilteredRowModel().rows;
              calculateSum(rowsToCalculate, "mensalidade_axs");

              return (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "1rem",
                    padding: "0.5rem",
                    width: "72%",
                    "@media (max-width: 1865px)": {
                      width: "68%",
                    },
                    "@media (max-width: 1643px)": {
                      width: "65%",
                    },
                    "@media (max-width: 1508px)": {
                      width: "57%",
                    },
                    "@media (max-width: 1332px)": {
                      width: "47%",
                    },
                  }}
                >
                  <div
                    style={
                      !table.getIsSomeRowsSelected() &&
                      !table.getIsAllRowsSelected()
                        ? {}
                        : { display: "none" }
                    }
                  >
                    <Button
                      sx={{
                        backgroundColor: "#6C5AF4",
                        "&:hover": {
                          backgroundColor: "#6C5AF4",
                        },
                      }}
                      color="primary"
                      onClick={handleExportData}
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Exportar
                    </Button>
                  </div>
                  <div
                    style={
                      !table.getIsSomeRowsSelected() &&
                      !table.getIsAllRowsSelected()
                        ? { display: "none" }
                        : {}
                    }
                  >
                    <Button
                      sx={{
                        backgroundColor: "#6C5AF4",
                        "&:hover": {
                          backgroundColor: "#6C5AF4",
                        },
                      }}
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      onClick={() =>
                        handleExportRows(table.getSelectedRowModel().rows)
                      }
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Exportar
                    </Button>
                  </div>
                  <Box
                    sx={{
                      flex: 1,
                      textAlign: "left",
                      display: "flex",
                      justifyContent: "center",
                      "@media (max-width: 1082px)": {
                        fontSize: "14px",
                        justifyContent: "flex-end",
                      },
                    }}
                  >
                    <span>
                      <span style={{ color: "#00000099" }}>
                        Total mensalidade AXS:
                      </span>{" "}
                      {somaMensalidade}
                    </span>
                  </Box>
                </Box>
              );
            }}
          />
        </ThemeProvider>
      </LocalizationProvider>
    </>
  );
};
